import { PRESENTATION, PRESENTATIONSEARCH, AUDIOVIDEO, SCHEDULEINVESTORMEET } from "./type";

const initialState ={presentation: '', presentationsearch: '', audiovideo: '', scheduleInvestorMeet:''};

const presentationR = (state = initialState, action) =>{
    switch(action.type){
        case PRESENTATION:
            return {...state, presentation: action.payload};
        case PRESENTATIONSEARCH:
            return {...state, presentationsearch: action.payload};    

        case AUDIOVIDEO:
            return {...state, audiovideo: action.payload};    
        case SCHEDULEINVESTORMEET:
            return {...state, scheduleInvestorMeet: action.payload};    

        default:
            return state;
    }
}

export default presentationR;